/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersback1Inputs */

const en_partnersback1 = /** @type {(inputs: Partnersback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All partners`)
};

const de_partnersback1 = /** @type {(inputs: Partnersback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Partner`)
};

/**
* | output |
* | --- |
* | "All partners" |
*
* @param {Partnersback1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersback1 = /** @type {((inputs?: Partnersback1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersback1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersback1(inputs)
	return de_partnersback1(inputs)
});
export { partnersback1 as "partnersBack" }